import { z } from 'zod';
// Un tirage unique fait du taux de citation un tirage au sort ; au-delà de 5 la
// facture monte plus vite que la précision.
export const AEO_MAX_SAMPLES = 5;
export const AEO_MIN_SAMPLES = 1;
// Appels simultanés au moteur. Rien n'interdit de tout lancer d'un coup : le
// plafond réel est le débit autorisé par le compte OpenAI, que seul l'usage
// révèle. Les dépassements sont réessayés, et le compteur de tirages perdus
// affiché après chaque run dit s'il faut redescendre.
export const AEO_MAX_CONCURRENCY = 45;
export const AEO_MIN_CONCURRENCY = 1;
export const createAeoPromptSchema = z.object({
    // Absent = groupe « Autres » dans le tableau de bord
    text: z.string().trim().min(1),
    topic: z.string().trim().optional(),
});
export const updateAeoPromptSchema = z.object({
    // Écarter ≠ désactiver. `isActive: false` arrête la MESURE ; `dismissed`
    // laisse la question mesurée et lui interdit seulement de produire un
    // conseil. Sans ce second axe, refuser une recommandation obligeait soit à
    // écrire l'article qu'elle réclamait, soit à cesser de mesurer la question.
    dismissed: z.boolean().optional(),
    isActive: z.boolean().optional(),
    text: z.string().trim().min(1).optional(),
    topic: z.string().trim().optional(),
});
/**
 * Reporter un conseil, ou lever le report (`until: null`).
 *
 * La date vient du CLIENT plutôt que d'une durée fixe côté serveur : « le mois
 * prochain » n'a de sens que dans le fuseau de celui qui clique, et une durée
 * en dur se désaccorderait de la cadence des analyses le jour où elle change.
 */
export const snoozeAeoRecommendationSchema = z.object({
    until: z.string().datetime().nullable(),
});
export const createAeoCompetitorSchema = z.object({
    name: z.string().trim().min(1),
    // Graphies alternatives rencontrées dans les réponses des moteurs
    aliases: z.array(z.string().trim().min(1)).default([]),
});
export const updateAeoSettingsSchema = z.object({
    brandName: z.string().trim().min(1).optional(),
    // Peut être vidée : une fiche fausse est pire qu'une fiche absente.
    agencyProfile: z.string().trim().optional(),
    // La virgule est interdite parce qu'elle est le séparateur de stockage : la
    // liste tient sur une ligne d'AppSetting. Un alias qui en contient repartirait
    // en deux à la relecture, et l'écran afficherait un alias que personne n'a
    // saisi. Refusé à l'entrée plutôt que corrigé en silence.
    brandAliases: z
        .array(z
        .string()
        .trim()
        .min(1)
        .refine((alias) => !alias.includes(','), {
        message: 'Un alias ne peut pas contenir de virgule',
    }))
        .optional(),
    // Les domaines de NOTRE site, saisis à part des alias : c'est ce réglage-là,
    // et lui seul, qui décide « cette page est la nôtre ». Refusé plutôt que
    // filtré en silence — un nom commercial glissé ici ne reconnaîtrait aucune
    // page, et l'utilisateur croirait l'avoir déclaré.
    brandDomains: z
        .array(z
        .string()
        .trim()
        .min(1)
        .toLowerCase()
        .refine((domain) => !domain.includes(','), {
        message: 'Un domaine ne peut pas contenir de virgule',
    })
        .refine((domain) => /^[^\s/]+\.[^\s/]+$/.test(domain), {
        message: 'Saisissez un domaine seul, par exemple massiliavoyages.fr',
    }))
        .optional(),
    concurrency: z.number().int().min(AEO_MIN_CONCURRENCY).max(AEO_MAX_CONCURRENCY).optional(),
    samples: z.number().int().min(AEO_MIN_SAMPLES).max(AEO_MAX_SAMPLES).optional(),
});
// Bornes incluses, `YYYY-MM-DD`. Le format est contraint ici parce que le
// service les recolle en timestamps : un `2026-8-1` passerait la validation
// d'une simple `z.string().date()` de certaines implémentations et donnerait un
// `Invalid Date` silencieux côté Prisma.
export const aiPagesQuerySchema = z.object({
    from: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    to: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
});
